import { render, staticRenderFns } from "./MilestoneDecisions.vue?vue&type=template&id=d842e5b0&"
import script from "./MilestoneDecisions.vue?vue&type=script&lang=js&"
export * from "./MilestoneDecisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports